import { mapErrorCodeToErrorText } from "./MapErrorCodeToErrorText";
import { FormErrorCode } from "../entities/FormErrorCode";
import { FormErrorType } from "../entities/FormErrorType";
import { filterCompoundSeparator } from "../page-query/consts/queryValueSeparators";

export function getFormErrorTypes(): FormErrorType[] {
    let tempDic: { [errorCode: string]: FormErrorType } = {};
    Object.values(FormErrorCode).forEach((errorCode) => {
        const errorCodeNumber = Number(errorCode);
        if (!isNaN(errorCodeNumber)) {
            let key = mapErrorCodeToErrorText(String(errorCode));
            const record = tempDic[key];
            if (record) {
                record.errorCode += `${filterCompoundSeparator}${errorCodeNumber}`;
            } else {
                tempDic[key] = {
                    errorCode: String(errorCode),
                    displayValue: key
                } as FormErrorType;
            }
        }
    });
    let result2: FormErrorType[] = [];
    for (const resultKey in tempDic) {
        result2.push(tempDic[resultKey]);
    }
    let errorCodes = ["noDoctorInsuranceGroup1", "insuranceGroup2"];
    for (let errorCode of errorCodes) {
        result2.push({
            errorCode: errorCode,
            displayValue: mapErrorCodeToErrorText(errorCode)
        });
    }
    return result2;
}

export interface StatusCodeType {
    statusCode: string;
    displayValue: string;
}
